import React from "react";

const DollarIcon = ({ width, height, color }) => {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.528 7.624C6.528 8.024 6.428 8.4 6.228 8.752C6.036 9.104 5.748 9.4 5.364 9.64C4.988 9.88 4.54 10.024 4.02 10.072V11.044H3.24V10.072C2.488 10 1.88 9.764 1.416 9.364C0.952 8.964 0.72 8.436 0.72 7.78H2.184C2.208 8.092 2.308 8.352 2.484 8.56C2.66 8.76 2.912 8.888 3.24 8.944V6.304C2.704 6.168 2.268 6.032 1.932 5.896C1.596 5.752 1.308 5.528 1.068 5.224C0.836 4.92 0.72 4.504 0.72 3.976C0.72 3.312 0.952 2.764 1.416 2.332C1.88 1.892 2.488 1.636 3.24 1.564V0.592H4.02V1.564C4.724 1.628 5.288 1.852 5.712 2.236C6.144 2.612 6.388 3.132 6.444 3.796H4.98C4.956 3.548 4.86 3.328 4.692 3.136C4.524 2.936 4.3 2.8 4.02 2.728V5.32C4.556 5.448 4.992 5.584 5.328 5.728C5.664 5.864 5.948 6.084 6.18 6.388C6.412 6.684 6.528 7.096 6.528 7.624ZM2.112 3.904C2.112 4.232 2.208 4.488 2.4 4.672C2.6 4.856 2.88 5.004 3.24 5.116V2.692C2.896 2.732 2.62 2.856 2.412 3.064C2.212 3.272 2.112 3.552 2.112 3.904ZM4.02 8.944C4.372 8.888 4.648 8.748 4.848 8.524C5.048 8.292 5.148 8.016 5.148 7.696C5.148 7.376 5.048 7.128 4.848 6.952C4.656 6.768 4.38 6.62 4.02 6.508V8.944Z"
        fill="white"
      />
    </svg>
  );
};

export default DollarIcon;
